import React, { useContext, useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
// reactstrap components
import {
    Button,
    Container,
    Row,
    Col,
    Spinner,
    Modal,
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup
} from "reactstrap";
import Select from 'react-select';
// core components
import LoggedinHeader from "../components/Headers/LoggedinHeader.js";
import LoggedinNavbar from "../components/Navbars/LoggedinNavbar.js";
import LoggedinFooter from "../components/Footers/LoggedinFooter.js";
import { AuthContext } from '../AuthContext';
import { AxiosContext } from '../AxiosContext';
import { AnimatePresence, motion } from "framer-motion";
import AddetailsSkeleton from "../skeleton-screens/AddetailsSkeleton";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ADModal from '../components/ADModal';
import Adstatus from '../components/Adstatus';
import Auditlog from '../components/Auditlog';
import LiveStreamModal from '../components/LiveStreamModal';
import { render } from "@testing-library/react";


function AddetailsNoEdit() {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { adid, status } = state;
    const auth = useContext(AuthContext);
    const { authAxios } = useContext(AxiosContext);
    const [isLoading, setIsLoading] = useState(false);
    const [modalMsg, setModalMsg] = useState('');
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [showSpinner, setShowSpinner] = useState(false);
    const [modalLocFlagged, setModalLocFlagged] = useState(false);
    const [modalLive, setModalLive] = useState(false);

    const [liveLocId, setLiveLocId] = useState('');
    const [liveLocMpSubType, setliveLocMpSubType] = useState('nocam');
    const [liveZipCode, setLiveZipCode] = useState('');
    const [adDetails, setAdDetails] = useState([]);
    const [dataLocationsSelected, setDataLocationsSelected] = useState([]);
    const [dataLocationsRemoved, setDataLocationsRemoved] = useState([]);
    const [userDetails, setUserDetails] = useState([]);
    const [discountMsg, setDiscountMsg] = useState(null);
    const [editLocNote, setEditLocNote] = useState(null);
    const [logView, setLogView] = useState(false);
    const [dataAreaDropdown, setDataAreaDropdown] = useState([]);
    const [streamUrl, setStreamUrl] = useState(null);

    document.documentElement.classList.remove("nav-open");
    React.useEffect(() => {
        document.body.classList.add("Addetailsnoedit-page");
        return function cleanup() {
            document.body.classList.remove("Addetailsnoedit-page");
        };
    });

    const renderSpinner = () => {
        if (showSpinner) {
            return (
                <Modal isOpen={showSpinner} centered={true} className="spinnerModal">
                    <div className="modal-body">
                        <Spinner color="primary">
                            Loading...
                        </Spinner>
                    </div>
                </Modal>

            );
        }
    };
    const showModal = (msg) => {
        setModalMsg(msg);
        setIsModalVisible(!isModalVisible);
    };

    const handleModal = () => showModal('');

    const renderOkButton = () => {
        return (
            <Button
                className="btn-round"
                color="primary"
                type="button"
                onClick={() => handleModal()}
            >
                <span style={{ color: '#0b1011', textTransform: 'none' }}>&nbsp;&nbsp; ok &nbsp;&nbsp;</span>
            </Button>
        );
    };

    const toggleModalFlagged = () => {
        setModalLocFlagged(!modalLocFlagged);
    };

    const toggleModalLive = (locid = null) => {
        if (!modalLive) {
            // Modal is opening, start the stream
            setModalLive(true);

        } else {
            // Modal is closing, cleanup
            setStreamUrl(null);
            setModalLive(false);
        }
    };

    const renderLiveView = (locid, zipcode, mpsubtype) => {
        if (status == 'active') {
            return (
                <div className="locationItemLiveViewContent" onClick={() => {
                    setLiveLocId(locid);
                    setLiveZipCode(zipcode);
                    setliveLocMpSubType(mpsubtype);
                    toggleModalLive(locid);
                }}>
                    <i className="nc-icon nc-tv-2" />
                    <span style={{ textDecoration: 'underline', cursor: 'pointer' }}> Live</span>
                </div>
            );
        }

    }

    const startLiveStream = async (locationId) => {
        try {
            console.log("Starting stream for location:", locationId);
            let url = '/startstream';
            let data = {
                data: {
                    id: locationId
                }
            };

            const response = await authAxios.post(url, data, { withCredentials: true });
            let result = response.data;

            if (!result.error) {
                const responseStreamUrl = result.data.stream_url;

                return responseStreamUrl;

            } else {
                console.error("API returned error:", result.error);
            }
        } catch (error) {
            console.error('Error starting live stream:', error);
        }
    };


    const renderLocations = () => {
        return dataLocationsSelected.map((locData, index) => {
            return (
                <div className="locationItemNoEdit" key={index}>
                    <div className="locationItemContentNoEdit">
                        <div className="locationItemContentTopNoEdit">
                            <span>{locData.type}   ({locData.size}&Prime;)  ({locData.orientation})  ({locData.price})</span>
                        </div>
                        <div className="locationItemContentBottomNoEdit">
                            <span>{locData.area}, {locData.city}, {locData.zipcode}</span>
                        </div>
                    </div>
                    <div className="locationItemLiveViewNoEdit">
                        {renderLiveView(locData.locid, locData.zipcode, locData.mpsubtype)}
                    </div>
                </div>
            );
        });
    }



    const triggerPayment = () => {
        //navigate('/paymentcf', { state: { adid: adid } });
        navigate('/mycart', { state: { adid: adid } });
    }

    const triggerEditLoc = async () => {
        try {
            setShowSpinner(true);
            let url;
            if (adid != '') {
                url = '/editlocation/' + adid;
            } else {
                throw "Error Occurred. Please re-login";
            }
            const response = await authAxios.get(url);
            if (typeof response.data.error === 'undefined' && typeof response.data.data !== 'undefined') {
                let result = response.data;
                if (result.data) {
                    setShowSpinner(false);
                    navigate('/addetails', { state: { adid: adid, status: 'incomplete' } });
                } else {
                    setShowSpinner(false);
                    throw "Error Occurred. Please retry";
                }
            } else {
                setShowSpinner(false);
                throw (response.data.error === undefined) ? 'Server error. Please retry' : response.data.error;
            }
            setShowSpinner(false);
        } catch (error) {
            if (typeof error.message === 'undefined') {
                showModal(error);
            } else {
                showModal(error);
            }
        }
    }

    const renderActionButton = () => {
        if (status == 'pending payment' && dataLocationsSelected.length > 0) {
            return (
                <Button
                    className="btn-round btn-createad"
                    color="primary"
                    onClick={() => triggerPayment()
                    }
                >
                    <span style={{ color: '#0b1011', textTransform: 'none' }}>&nbsp;Proceed to cart&nbsp;</span>
                </Button>

            );
        }
        if (status == 'pending approval' || status == 'active') {
            return (
                <></>
            );
        }

    }

    const renderEditLocButton = () => {
        if (dataLocationsRemoved.length > 0) {
            return (
                <Button
                    className="btn-round btn-createad"
                    color="primary"
                    onClick={() => triggerEditLoc()}
                >
                    <span style={{ color: '#0b1011', textTransform: 'none' }}>&nbsp;Edit Locations&nbsp;</span>
                </Button>
            );
        }
    }

    const renderDesignCost = () => {
        if (adDetails.designcost > 0) {
            return (
                <div className="cost">
                    <div className="costLeft">
                        <span>Design Cost:&nbsp;</span>
                    </div>
                    <div className="costRight">
                        <span>{adDetails.designcost}</span>
                    </div>
                </div>
            );
        }

    }

    const editAd = (adid, status) => {
        navigate('/vceditor', { state: { adid: adid, status: status } });
    };

    const renderEdit = () => {
        if (status == 'active') {
            return (
                <div className="adDetailsEdit">
                    <div className="adDetailsEditLeft">

                        <Button
                            className="btn-round btn-createad"
                            color="primary"
                            onClick={() => editAd(adid, status)}
                        >
                            <span style={{ color: '#0b1011', textTransform: 'none' }}>&nbsp;Edit&nbsp;</span>
                        </Button>
                    </div>
                    <div className="adDetailsEditRight"></div>
                </div>
            );
        } else {
            return (
                <></>
            );
        }
    }

    const goToCart = () => {
        navigate('/mycartbal', { state: { adid: adid } });
    }

    const renderCurrency = (currency) => {
        if (currency == 'INR') {
            return <>&#8377;</>;
        } else {
            return <></>;
        }
    };

    const renderPayBalance = () => {
        if (status == 'active' && adDetails.paidtype == 'half') {
            return (
                <Row>
                    <Col className="ml-auto mr-auto">
                        <div className="noEditDuration">
                            <span style={{ fontWeight: "bold" }}>Balance amount:&nbsp;&nbsp;</span>
                            <Button
                                className="btn-round"
                                color="primary"
                                type="button"
                                onClick={() => goToCart()}
                            >
                                <span style={{ color: '#0b1011', textTransform: 'none' }}>&nbsp;&nbsp; Pay &nbsp;&nbsp;{renderCurrency(adDetails.currency)}&nbsp;{adDetails.balance}&nbsp;&nbsp;</span>
                            </Button>
                        </div>
                    </Col>
                </Row>
            );
        }

    }

    const renderRemovedLocationsText = () => {
        if (typeof dataLocationsRemoved !== 'undefined' && dataLocationsRemoved.length > 0) {
            return (
                <Row>
                    <Col className="ml-auto mr-auto">
                        <div className="adDetailsReason" onClick={() => setModalLocFlagged(true)}>
                            <p style={{ textAlign: "justify" }}>
                                <span>Few locations you selected are already running at full capacity as of now. Please &nbsp;</span>
                                <span style={{ textDecorationLine: "underline", fontWeight: "bold", color: "#4d79ff", cursor: 'pointer' }}>click here</span>
                                <span>&nbsp;to see the locations that were removed. Your cost is adjusted accordingly with applicable discount for your chosen duration.</span>
                            </p>

                        </div>
                    </Col>
                </Row>
            );
        }
    };

    const renderRemovedLocations = () => {
        return dataLocationsRemoved.map((locData, index) => {
            return (
                <div className="locationItemSelected" key={index}>
                    <div className="locationItemSelectedContent">
                        <div className="locationItemSelectedtTop">
                            <span>{locData.type}   ({locData.size}&Prime;)  ({locData.orientation})  ({locData.price})</span>
                        </div>
                        <div className="locationItemSelectedBottom">
                            <span>{locData.area}, {locData.city}, {locData.zipcode}</span>
                        </div>
                        <div className="locationItemSelectedBottom">
                            <p style={{ paddingTop: '3px' }}>
                                <span style={{ fontSize: 'small', color: '#767676', fontWeight: '500' }}>Next available date:&nbsp;
                                    <span style={{ fontSize: 'small', color: '#b33c12', fontWeight: '500' }}>{locData.avldate}</span>
                                </span>
                            </p>
                        </div>
                    </div>
                    <div className="locationItemDelete">

                    </div>
                </div>
            );

        });
    };

    const renderThumbnail = () => {
        if (adDetails.adtype == "img") {
            return (
                <img
                    src={adDetails.img ? adDetails.img : adDetails.vista_img}
                    className="adDetailsImgContain"
                />

            );
        }
        if (adDetails.adtype == "video") {
            let srcType = "video/mp4";
            // if (adDetails.img == null) {
            //     srcType = "video/mp4";
            // }
            return (
                <video className="adDetailsImgContain" controls muted>
                    <source src={adDetails.img ? adDetails.img : adDetails.vista_img} type={srcType} />
                </video>

            );
        }
    };

    const renderThumbnailNew = () => {
        if (adDetails.adtype == "img") {
            return (
                <img
                    src={adDetails.new_img ? adDetails.new_img : adDetails.vista_new_img}
                    className="adDetailsImgContain"
                />
            );
        }
        if (adDetails.adtype == "video") {
            let srcType = "video/mp4";
            // if (adDetails.new_img == null) {
            //     srcType = "video/mp4";
            // }
            return (
                <video className="adDetailsImgContain" controls>
                    <source src={adDetails.new_img ? adDetails.new_img : adDetails.vista_new_img} type={srcType} />
                </video>
            );
        }
    };

    const renderPendingApprovalDesign = () => {
        if (adDetails.new_img) {
            return (
                <Row>
                    <Col className="ml-auto mr-auto">
                        <div className="adDetailsContainer">
                            <div className="adDetailsTitle">
                                <p>Below design will be active and displayed on screens after approval</p>
                                <p>Note: Even if Ad duration is changed, it will still play for the original duration you paid for</p>
                            </div>
                            <div className="adDetailsImg">
                                {renderThumbnailNew()}
                            </div>
                            <div className="adDetailsImgWidget">
                                <div className="adDetailsImgWidgetWeather">
                                    <span style={{ color: "#ffffff" }}>Mar 27 Wed &nbsp;&nbsp;25&deg;C &nbsp;Today: Partly Cloudy</span><i style={{ color: "#fff", paddingLeft: "5px", marginTop: "3px" }} className="nc-icon nc-cloud-upload-94" />
                                </div>
                                <div className="adDetailsImgWidgetTime">
                                    <span style={{ color: "#ffffff" }}>4:00 Pm</span>
                                </div>

                            </div>
                            <div className="adDetailsStatus">
                                <Adstatus status={adDetails.activeedit} />
                            </div>
                        </div>
                    </Col>
                </Row>
            );

        }

    }

    const convertDate = (dataDate) => {
        if (dataDate) {
            const utcDate = new Date(dataDate);
            const myLocalDate = new Date(Date.UTC(
                utcDate.getFullYear(),
                utcDate.getMonth(),
                utcDate.getDate(),
                utcDate.getHours(),
                utcDate.getMinutes()
            ));
            return myLocalDate.toLocaleString("en-IN");
        } else {
            return '';
        }

    }

    const renderExpiryDate = () => {
        if (status == 'active' || status == 'in active') {
            return convertDate(adDetails?.expirydate);
        } else {
            return '';
        }
    }

    const renderCreatedDate = () => {
        return convertDate(adDetails?.adcreated);
    }

    const fetchData = async () => {
        try {

            setIsLoading(true);
            let url;
            if (adid != '') {
                url = '/locationnoedit/ad/' + adid;
            } else {
                throw "Error Occurred. Please re-login";
            }
            const response = await authAxios.get(url);
            var responseData = [];
            let result = response.data;

            if (result.data) {
                responseData = result.data;
                let adDetailsObject = (responseData.adDetails) ? responseData.adDetails : [];
                let numDays = 0;

                if (adDetailsObject.durationtype == 'days' || adDetailsObject.durationtype == 'weeks' || adDetailsObject.durationtype == 'months') {
                    if (adDetailsObject.duration != '') {
                        numDays = adDetailsObject.duration;
                    }
                    if (adDetailsObject.durationtype == 'weeks' && numDays > 0) {
                        numDays = 7 * numDays;
                    } else if (adDetailsObject.durationtype == 'months' && numDays > 0) {
                        numDays = 30 * numDays;
                    }
                }
                let discmsg = '';
                if (numDays >= 30) {
                    discmsg = '25% discount applied';
                } else if (numDays >= 15) {
                    discmsg = '15% discount applied';
                } else if (numDays >= 7) {
                    discmsg = '10% discount applied';
                } else {
                    discmsg = '';
                }
                if (adDetailsObject.cost <= 0) {
                    discmsg = '';
                }

                setAdDetails(adDetailsObject);
                setDataLocationsSelected(responseData.locations);
                setDataLocationsRemoved(responseData.locationsremoved);

                let areaGroups = responseData.locations.reduce((acc, loc) => {

                    if (!acc[loc.area]) {
                        acc[loc.area] = { label: loc.area, value: loc.locid };
                    }
                    return acc;
                }, {});

                areaGroups = { "All": { label: "All", value: 0 }, ...areaGroups };

                setDataAreaDropdown(Object.values(areaGroups));
                if (status == 'pending payment' && responseData.locationsremoved.length > 0) {
                    setEditLocNote('Note: On edit locations you need to go through whole approval process again');
                }

                setUserDetails(responseData.userDetails);
                setDiscountMsg(discmsg);

            } else {
                throw "Server error. Unable to fetch data";
            }

            setIsLoading(false);
        } catch (error) {

            showModal("Server Error. Please refresh or relogin");
            setIsLoading(false);
        }
    };

    const renderStreamType = () => {
        if (liveLocMpSubType === 'nocam') {
            let url = process.env.REACT_APP_LOC_STORE_URL + "/" + liveLocId + '-' + liveZipCode + '.mp4';
            return (
                <div className="adDetailsImg">
                    <video className="adDetailsImgContain" controls>
                        <source src={url} type="video/mp4" />
                    </video>
                </div>
            );
        } else {

            return (
                <div className="adDetailsLive">
                    <LiveStreamModal streamUrl={streamUrl} />
                </div>
            );


        }
    };

    useEffect(() => {
        if (modalLive && liveLocMpSubType === 'withcam' && liveLocId) {
            let timer;
            const fetchStream = async () => {
                const url = await startLiveStream(liveLocId);
                timer = setTimeout(() => {
                    setStreamUrl(url);
                }, 10000);
            };
            fetchStream();
            return () => clearTimeout(timer);
        }
    }, [modalLive, liveLocId, liveLocMpSubType]);

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (streamUrl && liveLocId) {
            let url = '/streamping';
            let data = {
                data: {
                    id: liveLocId
                }
            };

            const interval = setInterval(async () => {
                try {
                    await authAxios.post(url, data);
                    console.log('Stream ping successful for location:', liveLocId);
                } catch (error) {
                    console.error('Stream ping failed:', error);
                }
            }, 10000); // every 10 seconds

            return () => clearInterval(interval); // cleanup on stream stop
        }
    }, [streamUrl, liveLocId]); // Add liveLocId to dependencies


    return (
        <>
            <LoggedinHeader />
            <LoggedinNavbar />
            <AnimatePresence>
                <div className="main">
                    <div className="text-center">
                        {isLoading && (
                            <Container>
                                <AddetailsSkeleton exit={{ opacity: 0 }} />
                            </Container>
                        )}
                        <Container>
                            {!isLoading && (
                                <>
                                    <Row>
                                        <Col className="ml-auto mr-auto">
                                            <div className="adDetailsContainer">
                                                <div className="adDetailsTitle">
                                                    <h4>{adDetails.name}</h4>
                                                </div>
                                                {renderEdit()}
                                                <div className="adDetailsImg">
                                                    {renderThumbnail()}
                                                </div>
                                                <div className="adDetailsImgWidget">
                                                    <div className="adDetailsImgWidgetWeather">
                                                        <span style={{ color: "#ffffff" }}>Mar 27 Wed &nbsp;&nbsp;25&deg;C &nbsp;Today: Partly Cloudy</span><i style={{ color: "#fff", paddingLeft: "5px", marginTop: "3px" }} className="nc-icon nc-cloud-upload-94" />
                                                    </div>
                                                    <div className="adDetailsImgWidgetTime">
                                                        <span style={{ color: "#ffffff" }}>4:00 Pm</span>
                                                    </div>

                                                </div>
                                                <div className="adDetailsStatus">
                                                    <Adstatus status={status} />
                                                </div>
                                                <div className="adDetailsStatus">
                                                    <p>
                                                        <span style={{ color: "#b33c12" }}>* If you edit Ad and is not showing up in preview below. Please check back in few minutes, Ad processing may be in progress</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    {renderPendingApprovalDesign()}
                                    {renderRemovedLocationsText()}
                                    {renderPayBalance()}
                                    <Row>
                                        <Col className="ml-auto mr-auto">
                                            <div className="noEditDuration">
                                                <span style={{ fontWeight: "bold" }}>Duration:&nbsp;&nbsp;</span><span>{adDetails.duration} {adDetails.durationtype}</span>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="ml-auto mr-auto">
                                            <div className="noEditDuration">
                                                <span style={{ fontWeight: "bold" }}>
                                                    {(status != 'in active') && (<>Ad expires on </>)}
                                                    {(status == 'in active') && (<>Ad expired on </>)}
                                                    :&nbsp;&nbsp;</span><span>{renderExpiryDate()}</span>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col className="ml-auto mr-auto">
                                            <div className="noEditDuration">
                                                <span style={{ fontWeight: "bold" }}>
                                                    Ad Created on
                                                    :&nbsp;&nbsp;</span><span>{renderCreatedDate()}</span>
                                            </div>
                                        </Col>
                                    </Row>
                                    {(status == 'active' || status == 'in active') && (
                                        <Row>
                                            <Col className="ml-auto mr-auto">
                                                <div className="noEditDuration" onClick={() => setLogView(true)}>
                                                    <span style={{ textDecorationLine: "underline", fontWeight: "bold", color: "#4d79ff", cursor: 'pointer' }}>View log</span>
                                                </div>
                                            </Col>
                                        </Row>
                                    )}
                                    <Auditlog
                                        isVisible={logView}
                                        userDetails={userDetails}
                                        adDetails={adDetails}
                                        areaDropdown={dataAreaDropdown}
                                        setShowSpinner={setShowSpinner}
                                        setLogView={setLogView}
                                        showModal={showModal}
                                        authAxios={authAxios}
                                        fromScreen={"user"}
                                    />
                                    <Row>
                                        <Col className="ml-auto mr-auto">
                                            <div className="noEditLocationContainer">
                                                <div style={{ marginBottom: "20px" }}>
                                                    <span style={{ fontWeight: "bold" }}>Locations: </span>
                                                </div>
                                                <div className="noEditLocations">
                                                    {renderLocations()}
                                                    <div className="editLocNote">
                                                        <p><span style={{ color: "#b33c12" }}></span>&nbsp;{editLocNote}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                    <Modal isOpen={modalLocFlagged} centered={true} toggle={toggleModalFlagged}>
                                        <div className="modal-header">
                                            <button
                                                aria-label="Close"
                                                className="close"
                                                type="button"
                                                onClick={toggleModalFlagged}
                                            >
                                                <span aria-hidden={true}>×</span>
                                            </button>
                                            <h5
                                                className="modal-title text-center"
                                                id="exampleModalLabel"
                                            >
                                                Occupied Locations
                                            </h5>
                                        </div>
                                        <div className="modal-body">
                                            <div style={{ marginBottom: "5px" }}>
                                                <span>Belows locations are at full capacity now and removed from your selection</span>
                                            </div>
                                            {renderRemovedLocations()}
                                        </div>
                                    </Modal>
                                    <Modal isOpen={modalLive} centered={true} toggle={toggleModalLive} size="xl">
                                        <div className="modal-header">
                                            <button
                                                aria-label="Close"
                                                className="close"
                                                type="button"
                                                onClick={toggleModalLive}
                                            >
                                                <span aria-hidden={true}>×</span>
                                            </button>
                                            <h5
                                                className="modal-title text-center"
                                                id="exampleModalLabel"
                                            >
                                                Live feed - if distorted feed is observed it is just a network problem but it runs fine on actual displays.
                                            </h5>
                                        </div>
                                        <div className="modal-body">
                                            <div className="adDetailsContainer">
                                                {renderStreamType()}
                                            </div>

                                        </div>
                                    </Modal>
                                    <div className="AddetailsSubmitContainer">
                                        <div className="submitContainerLeft">
                                            {renderActionButton()}
                                            {renderEditLocButton()}
                                        </div>
                                        <div className="submitContainerRight">
                                            <div className="impressions">
                                                <div className="impressionsLeft">
                                                    <span>Estimated <br />Impressions:&nbsp;</span>
                                                </div>
                                                <div className="impressionsRight">
                                                    <span>{adDetails.estimatedImpressions} - {adDetails.estimatedImpressions * 10}</span>
                                                </div>
                                            </div>
                                            <div className="cost">
                                                <div className="costLeft">
                                                    <span style={{ fontWeight: 'bold' }}>Subtotal:&nbsp;</span>
                                                </div>
                                                <div className="costRight">
                                                    <span>{adDetails.cost}</span>
                                                </div>
                                            </div>
                                            {renderDesignCost()}
                                            <div className="discountMsg">
                                                <span style={{ color: '#44c47d' }}>{discountMsg}</span>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </Container>
                    </div>
                    <ADModal
                        isVisible={isModalVisible}
                        msg={modalMsg}
                        children={renderOkButton()}
                    />
                    {renderSpinner()}

                </div>
            </AnimatePresence>
            <LoggedinFooter />
        </>
    );

}

export default AddetailsNoEdit;